import { z } from 'zod';
import { emailSchema } from '@pages/Auth/schemas/auth.schema';
import { ERROR_MESSAGE } from '@shared/constants/errorMessage.constant';
import { USER_STATUSES, USER_TYPES } from '@shared/constants/user.constant';
import { permissionsSchema } from '@shared/schemas/permissionService.schema';

const whoAmISchema = z.object({
  id: z.uuid(),
  name: z
    .string()
    .min(1, { message: ERROR_MESSAGE.required })
    .max(50, { message: ERROR_MESSAGE.maxLength(50) }),
  username: z.string().optional(),
  email: emailSchema,
  status: z.enum([USER_STATUSES.active, USER_STATUSES.invited]),
  type: z.enum([USER_TYPES.user, USER_TYPES.api_user]),
  roles: z.array(z.string()),
  permissions: permissionsSchema
});

const whoAmIResponseSchema = z.object({
  user: whoAmISchema
});

export { whoAmISchema, whoAmIResponseSchema };
